export const MINERVA_ONDEMAND_IDS = [
  'minerva_monthly_ondemand_a1',
  'minerva_quarterly_ondemand_35',
  'minerva_biannual_ondemand_65',
  'minerva_annual_ondemand_120_30trial',
];
